"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RequestPayload = /** @class */ (function () {
    function RequestPayload() {
    }
    return RequestPayload;
}());
var RequestConfig = /** @class */ (function () {
    function RequestConfig() {
    }
    return RequestConfig;
}());
var ResponseConfig = /** @class */ (function () {
    function ResponseConfig() {
    }
    return ResponseConfig;
}());
var Base = /** @class */ (function () {
    function Base() {
        this.isCrossDomainCookie = true;
    }
    return Base;
}());
exports.Base = Base;
var Request = /** @class */ (function (_super) {
    __extends(Request, _super);
    function Request(config) {
        var _this = _super.call(this) || this;
        _this.action = config.action;
        _this.payload = config.payload;
        _this.disableNewRedirect = config.disableNewRedirect;
        _this.needToLogin = config.needToLogin;
        return _this;
    }
    return Request;
}(Base));
exports.Request = Request;
var Response = /** @class */ (function (_super) {
    __extends(Response, _super);
    function Response(config) {
        var _this = _super.call(this) || this;
        _this.action = config.action;
        _this.payload = config.payload;
        _this.disableNewRedirect = config.disableNewRedirect;
        _this.needToLogin = config.needToLogin;
        return _this;
    }
    return Response;
}(Base));
exports.Response = Response;
var InvalidActionError = /** @class */ (function (_super) {
    __extends(InvalidActionError, _super);
    function InvalidActionError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.message = 'Invalid action';
        return _this;
    }
    return InvalidActionError;
}(Error));
exports.InvalidActionError = InvalidActionError;
var InvalidConfigError = /** @class */ (function (_super) {
    __extends(InvalidConfigError, _super);
    function InvalidConfigError(message) {
        return _super.call(this, "Config is invalid! " + message) || this;
    }
    return InvalidConfigError;
}(Error));
exports.InvalidConfigError = InvalidConfigError;
